import {
  Component,
  DestroyRef,
  ElementRef,
  HostListener,
  inject,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { ActivatedRoute } from '@angular/router';
import { Eventconfig } from '../../../shared/eventconfig';
import { EventconfigStoreService } from '../../../shared/eventconfig-store.service';
import { Eventstatus } from '../../../shared/eventstatus';
import { PlayerStoreService } from '../../../shared/player-store.service';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { ISlide, ISlideObject, Slide, SlidePlaylist } from '../../../shared/slide';
import { MatAccordion } from '@angular/material/expansion';
import { Eventinit } from '../../../shared/eventinit';
import { Title } from '@angular/platform-browser';
import { UserAssignService } from '../../../shared/user-assign.service';
import { EventsetupStoreService } from '../../../shared/eventsetup-store.service';
import { Eventsetup } from '../../../shared/eventsetup';
import { AuthService } from '../../../core/_services/auth.service';
import { TokenStorageService } from '../../../core/_services/token-storage.service';
import { VodQuestionListComponent } from '../../../features/vod-question-list/vod-question-list.component';
import { UserVoteQuestionListComponent } from '../../../features/user-vote-question-list/user-vote-question-list.component';
import { QuestionStoreService } from '../../../shared/question-store.service';
import { SlideStoreService } from '../../../shared/slide-store.service';
import { Observable, Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LogService } from '../../../shared/log.service';

import { MyStream } from '../../../shared/myStream';
import { io, Socket } from 'socket.io-client';
import { ListReorderService } from '../../../shared/list-reorder.service';
import { MediaLibraryStoreService } from '../../../shared/media-library-store.service';
import { PollStoreService } from '../../../shared/poll-store.service';
import { pollTabLabel, pollText, ViewerPoll, itemPolls, PollItem, pollItemLabel } from '../../../shared/poll';

// Animation zur Überblendung beim Wechsel auf andere Child-Components.
@Component({
  selector: 'lse-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('1.5s ease-in', style({ height: 0, opacity: 1 }))
      ]),
      transition(':leave', [style({ height: 0, opacity: 1 }), animate('1s ease-in', style({ height: 0, opacity: 0 }))])
    ]),
    trigger('slideInOut', [
      state(
        'in',
        style({
          overflow: 'hidden',
          height: '*'
        })
      ),
      state(
        'out',
        style({
          overflow: 'hidden',
          height: '0px'
        })
      ),
      transition('in => out', animate('250ms ease-in-out')),
      transition('out => in', animate('250ms ease-in-out'))
    ]),
    trigger('hoverInOut', [
      state(
        'open',
        style({
          display: 'flex',
          opacity: '1'
        })
      ),
      state(
        'closed',
        style({
          display: 'none',
          opacity: '0'
        })
      ),
      transition('open => closed', [animate('.3s', style({ opacity: 0 }))]),
      transition('closed => open', [animate('.3s', keyframes([style({ display: 'flex' }), style({ opacity: 1 })]))])
    ]),
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1000ms ease-in', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('1000ms ease-in', style({ opacity: 0 }))
      ])
    ])

  ]
})
/**
 * Zentralkomponente (FR - 2021/02/10)
 *
 * Die home-Komponente führt alle anderen Komponenten zusammen und initialisiert ein Event.
 * Die verschiedenen Ajax-Aufrufe zum Abruf von Status- und Konfigurationsinformationen, werden in ngOnInit ausgelöst.
 * Alle Child-Komponenten haben die home-Komponente als gemeinsamen Parent.
 * Übergabe von Variablen zwischen Komponenten muss also hierüber laufen.
 *
 */
export class HomeComponent implements OnInit, OnChanges {
  @ViewChild('player') playerComponent;
  @ViewChild(MatAccordion) accordion: MatAccordion; // Holt Accordion-Objekt (Angular Materials).
  @ViewChild(VodQuestionListComponent) vodList;
  @ViewChild(UserVoteQuestionListComponent) userVoteQuestionList: UserVoteQuestionListComponent;
  @ViewChild('slideHistoryChild', { read: ElementRef }) public slideHistoryChild: ElementRef;
  
  @Input() eToken: string;
  @Input() uMode: 'int' | 'ext' = 'ext';
  @Input() uAssigendStream: MyStream = { ip: 'ext' };

  private nodeServiceUrl = environment.production ? "event-backend" : "test-event-backend";

  eConfig: Eventconfig;
  // Hält ein Objekt Eventconfig. Alle zur Laufzeit unveränderlichen Eventvariablen werden in diesem Objekt abgebildet.
  eLang: string; // Eventsprache
  eLangUsed: string;
  eLangGlob: any; // Sprachglobals
  eSetup: Eventsetup;
  eInit: Eventinit; // Pfad zum Eventordner (z.B. 100001_test)
  eStream: string; // Stream- oder Videoadresse für den Videoplayer
  eStatus: Eventstatus;
  // Hält ein Objekt vom Typ Eventstatus.
  // Eventstatus enthält alle zur Laufzeit veränderlichen Statusinformationen. Wird regelmäßig durch myGetStatus aktualisiert.
  statusInterval: any; // Leeres Interval für Status-Aktualisierung vom Server.
  slideInterval: any; // Leeres Interval für Slide-Aktualisierung vom Server.
  playtimeInterval: any; // Leeres Interval für den Abruf der aktuellen Playtime in VoD.
  activeSlideInterval: any; // Leeres Interval für Slide-Aktualisierung aus der Applikation selbst.
  eActiveSlide: Slide; // Aktuell angezeigte Slide.
  panelOpenState = false; // Steuert Accordion und definiert das Panel als initial geschlossen.


  eventFolder: string;
  languages: string[];

  intervalKickoff = false;
  // Deaktiviert initial das Interval zum Abruf der Slides um Timing-Probleme zu verhindern.
  // Interval wird nach Status-Initialisierung gestartet.
  isAuthenticated = false; // Nutzer initial nicht authentifiziert. Wenn false, Anzeige Passwort-Eingabe.
  pCurrentPlaytime = 0; // Aktuelle Playtime in VoD.
  serverDisplay = '';
  uInternal = false;
  uInternalInterval: any;
  uInternalComplete = false;
  showPassword = false;
  preAuth = false;
  eEmergency = '';
  eOptionalTxt = '';
  eOptionalLink = '';
  eOptionalLinkDesc = '';
  screenwidth = document.body.offsetWidth;
  vodPage = 1;
  vodCount: number;
  vodQDisplay: number[];
  vodFrom: number;
  vodTo: number;
  eStreamSrc: Observable<any>;

  pInit = false;
  slideIsCustom = false;
  uiAssetsPrefix = environment.imgAssets;
  environmentVars = environment;
  posterPic: string;
  secondLogoWidth: number;
  useLiveUi: boolean;
  usePlaybackrates: number[] = [];
  tempScroll = false;
  hamburger: boolean;
  selectedLanguage: string;

  fullLanguage: any[] = [];
  down = false;
  // Mediathek
  mFromMediaLib = false;
  mToken = '';
  eTrackerCode = '';
  eTrackerCookies = '';
  mediaLink: any;
  mediaLibToken: any[];
  mBackLinkEncoded = '';
  mBackLinkDecoded = '';
  url: string;
  // Show Features
  showSlides = true;
  showQuestions = false;
  // Umfrage-Tab gewählt. Eigenes Flag, weil myGetStatus() showSlides/showQuestions bei jeder
  // Statusabfrage neu setzt — die Wahl des Zuschauers würde sonst nach 10 s zurückspringen.
  showPolls = false;
  showPodium: string;
  showSlideMobile = 'in';
  showQuestionVod = 'in';
  showSidebarDescription = 'out';
  showEventDescription = 'in';

  slideLoadComplete = false;

  form: any = {};
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  email: string;
  user: any;

  debugAssignServer = 'ext';
  mailSubjectServer = '';

  statusIntervalPeriod = 10000; // Intervalausführung zum Abruf des Status in ms.

  // eStatusObj.isLive = false;
  subscription: Subscription[] = [];


  showHamburger = false;

  SOCKET_ENDPOINT = environment.apiUrl;
  socketEventWatcher: Socket;

  showDropdownUserVoteQuestions = false;

  PlayerService: PlayerStoreService = inject(PlayerStoreService);

  constructor(
    private activatedRoute: ActivatedRoute,
    private vs: PlayerStoreService,
    private ep: EventsetupStoreService,
    private as: AuthService,
    protected qs: QuestionStoreService,
    private ss: SlideStoreService,
    private tokenStorage: TokenStorageService,
    private us: UserAssignService,
    private titleService: Title,
    private logger: LogService,
    private renderer: Renderer2,
    protected listReorderService: ListReorderService,
    @Inject(DOCUMENT) private cssDoc: any,
    @Inject(DOCUMENT) private eTracker
  ) {

  }

  private es = inject(EventconfigStoreService);
  readonly activeLang = this.es.activeLang;

  // Das Mediathek-Menü gehört dem Header. Hier nur gelesen: solange es offen ist, steht
  // der Header fix und der Inhalt braucht den Abstand darunter.
  protected readonly mediaLib = inject(MediaLibraryStoreService);

  // Umfragen: Die Seite hält die Verbindung selbst, damit der Umfrage-Tab erscheint, sobald
  // es eine Umfrage gibt — die Umfrage-Komponente wird erst gezeigt, wenn der Tab gewählt ist.
  protected readonly pollStore = inject(PollStoreService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.pollStore.connect();
    this.destroyRef.onDestroy(() => this.pollStore.disconnect());
    /*
        console.log('token' + this.tokenStorage.getToken());
    */

    // Zunächst werden die URL-Parameter ausgelesen. Param token ist implizit,
    // es wird also der nicht näher bezeichnete URL-Parameter als 'token' definiert.
    // if (this.tokenStorage.getToken() && this.tokenExpired(this.tokenStorage.getToken())) {
    //   this.logger.log('Token expired');
    // }
    if (this.uMode === 'int') {
      this.debugAssignServer = this.us.getSuccessServer();
    }
    //this.myInitEvent(this.eToken);
    this.url = this.eToken;
    this.myGetConfig();
    this.subscription.push(
      this.PlayerService.timeUpdate$.subscribe(time => {
        if (this.playerComponent) {
            this.playerComponent.playAt(time);}
      }),
    )

  }

  ngOnChanges() {
    const styles = this.cssDoc.getElementById('secondLogo');
    if (styles) {
      styles.innerHTML = this.es.getSecondLogoWidth;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenwidth = window.innerWidth;
    // Podium immer sichtbar ab ansicht 3
    if (this.screenwidth >= 1024) {
      this.showPodium = 'in';
    }
  }

  @HostListener('window:load', ['$event'])
  onLoad(event) {
    if (/iP(hone|ad)/.test(window.navigator.userAgent)) {
      document.body.addEventListener('touchstart', function() {
      }, false);
    }
  }



  voteHeight(value: string) {
    setTimeout(() => {
      const voteheight = this.cssDoc.createElement('STYLE') as HTMLStyleElement;
      voteheight.id = 'votingData';
      voteheight.innerHTML = this.es.setVoteHeight(value);
      this.renderer.appendChild(this.cssDoc.head, voteheight);
    }, 200);
  }

  // Ab hier Methoden der Komponente.
  // private tokenExpired(token: string) {
  //   const expiry = JSON.parse(atob(token.split('.')[1])).exp;
  //   this.logger.log('Test Token');
  //   this.logger.log('iss: ' + JSON.parse(atob(token.split('.')[1])).iss + ' window location: ' + window.location.href);
  //   const iss = JSON.parse(atob(token.split('.')[1])).iss;
  //   this.logger.log('Token: ' + iss === window.location.href);
  //   return Math.floor(new Date().getTime() / 1000) >= expiry;
  // }

  myInitEvent(token: string) {
    /**
     * @param token: Übergebenes Token aus URL.
     * Subscribed auf initEvent des Eventconfig-Service. Gibt den Ordnerpfad auf dem Server zum entsprechenden Event zurück.
     */
    this.es.initEvent(token).subscribe((p) => {
      this.eInit = p;
      console.log('Event initialized', this.eInit);
      if (this.eInit === null || this.eInit === undefined) {
        window.location.href = this.environmentVars.apiUrl + this.environmentVars.eventPrefix + 'misc/no_token.php';
      } else {

        // this.handleAuth(); // Abruf Config. Noch nicht! Erst Setup!
        this.myGetConfig();
      }
    });

  }

  handleAuth() {
    if (this.mToken !== '') {
      this.as
        .mediaLibAuth(
          this.mToken,
          this.mBackLinkDecoded.substring(this.mBackLinkDecoded.lastIndexOf('/') + 1).split('?')[0]
        )
        .subscribe(
          (data) => {
            this.preAuth = true;
            if (data) {
              this.tokenStorage.saveToken(data.jwt);
              this.tokenStorage.saveUser(data);
              this.mediaLibToken = data.tokens;
              this.email = data.email;
              this.isLoginFailed = false;
              this.isLoggedIn = true;
              this.logger.log('AUTH TOKEN: ' + data.jwt);
              this.mFromMediaLib = true;

              // this.myGetConfig();
              this.kickOffEvent();
              this.isAuthenticated = true;
            } else {
              this.tokenStorage.signOut();
              this.showPassword = true;
            }
          },
          (err) => {
            document.location.href = this.mBackLinkDecoded;
            this.tokenStorage.signOut();
            this.errorMessage = err.error.message;
            this.isLoginFailed = true;
          }
        );
    } else if (this.tokenStorage.getToken() !== null) {
      // this.myGetConfig();
      this.kickOffEvent();
      this.preAuth = true;
      this.isAuthenticated = true;
    } else {
      this.as.initAuth(this.uMode).subscribe(
        (data) => {
          /*          console.log(data);
                    console.log(this.uMode);*/
          this.preAuth = true;
          if (data) {
            this.tokenStorage.saveToken(data.jwt);
            this.tokenStorage.saveUser(data);
            this.email = data.email;
            this.isLoginFailed = false;
            this.isLoggedIn = true;
            this.logger.log('AUTH TOKEN: ' + data.jwt);
            // this.myGetConfig();
            this.kickOffEvent();
            this.isAuthenticated = true;
          } else {
            this.logger.log('No Token. Go to Password');
            this.showPassword = true;
          }
        },
        (err) => {
          this.errorMessage = err.error.message;
          this.isLoginFailed = true;
        }
      );
    }
  }


  myGetConfig() {
    /**
     * Ruft Eventconfig und -sprachen einmalig ab. Definiert die aktuell genutzte Sprache und setzt diese in Eventservice.
     * Revamp nötig
     */

    /**
     * Nutzer betritt Seite. Es wird geprüft ob intern. Solange passiert nichts anderes.
     * Dann Aufruf Setup mit Parameter int oder ext. Setup ruft auf dem Server ab: Mode (int/ext), Passwort ja/nein
     * Wenn kein Passwort: Setup gibt jwt zurück. Wenn Passwort: Gibt nichts zurück und Passwortabfrage
     * Wenn authentifiziert: Es wird externe Streamadresse (falls ext Streaming) und Applikation zurückgegeben
     * Wenn interner Zuschauer: getStream auf Verteilserver. Adresse kommt zurück, Applikation baut sich die richtige Adresse
     * Noch zu klären: Kann so der Stream getauscht werden? Wahrscheinlich kein Rückschritt zur alten Software
     */

    this.es.getEventLang().subscribe({
      next: (p) => {
        this.eLang = p;
        this.languages = p
        this.activatedRoute.queryParams.subscribe((qparams) => {
          if (qparams.medialib) {
            this.mToken = encodeURIComponent(qparams.medialib);
            this.eTrackerCode = encodeURIComponent(qparams.eTracker);
            this.eTrackerCookies = encodeURIComponent(qparams.eTrackerCookies);
            /*console.log(!!this.eTrackerCookies, 'trackercookies');*/
            if (this.eTrackerCookies === 'true' || this.eTrackerCookies === 'false') {
              this.handleETracker(this.eTrackerCode, this.eTrackerCookies);
            }
          }
          if (qparams.back) {
            this.mBackLinkEncoded = qparams.back;
            this.mBackLinkDecoded = decodeURI(atob(qparams.back));
          }
          if (qparams.ln) {
            if (this.eLang.includes(qparams.ln)) {
              this.es.setActiveLang(qparams.ln);
              this.eLangUsed = qparams.ln;
            }
          } else {
            this.es.setActiveLang(this.eLang[0]);
            this.eLangUsed = this.eLang[0];
          }
        });
        this.ep
          .getSetup() // NEW SETUP
          .subscribe((t) => {
            this.eSetup = t;
            this.eventFolder = this.eSetup.slides_folder.split('/')[0];
            this.setEventWatcherSocketConnection();
            this.es.getSecondLogo(this.eSetup.secondLogoId, this.eSetup.useDefault).subscribe((l) => {
              this.eSetup.secondLogo = l;
              if (l?.width) {
                this.es.setSecondLogoWidth(this.eSetup.secondLogo.width);
              }
            });
            if (this.eSetup.mode[0] === 'int' && this.eSetup.mode.length === 1 && this.uAssigendStream.ip === 'ext') {
              window.location.href =
                this.environmentVars.apiUrl + this.environmentVars.eventPrefix + 'misc/no_access.php';
            }
            setTimeout(() => {
              this.slideLoadComplete = true;
            }, 300);
            this.es.getConfig(this.es.getActiveLang()).subscribe(
              (e) => {
                this.eConfig = e;
                this.es.setConfigStore(this.eConfig);
                this.ep.setStoredSetup(this.eSetup);
                this.eLangGlob = this.es.getLangGlobals();
                this.titleService.setTitle(this.eConfig.title);
                this.getConfigOnInterval();
                this.getLangOverwrites();

                // Event starten nachdem Setup und Config geladen sind
                this.kickOffEvent();
              },
              (err) => this.logger.log('HTTP Error' + err)
            );

          });
      },
      error: (err) => this.logger.log('HTTP Error getEventLang: ' + err)
    });
  }

  getConfigOnInterval() {
    setInterval(() => {
      this.es.getConfig(this.es.getActiveLang()).subscribe(
        (e) => {
          this.eConfig = e;
          this.es.setConfigStore(this.eConfig);
          this.eLangGlob = this.es.getLangGlobals();
          this.titleService.setTitle(this.eConfig.title);
          this.getLangOverwrites();
        },
        (err) => this.logger.log('HTTP Error ' + err)
      );
    }, 30000);
  }

  getLangOverwrites() {
    if (this.eConfig.txtChapter_pl !== undefined) {
      this.eLangGlob.translateQuestions = this.eConfig.txtChapter_pl;
    }
    if (this.eConfig.txtChapter_sg !== undefined) {
      this.eLangGlob.translateQuestion = this.eConfig.txtChapter_sg;
    }
  }

  kickOffEvent() {
    this.myGetStatus(); // Abruf initialer Status
    this.vodFrom = 1;
    this.vodTo = +this.eSetup.vod_pageSize;
    this.es.getStatus().subscribe((p) => {
      this.eStatus = p;
      this.isLoading = false;
      this.voteHeight(this.eStatus.voteHeight);
      this.showPodium = this.eStatus.user_vote_questions ? 'out' : 'in';
      if (this.eStatus.user_strawpoll && !this.tempScroll) {
        this.tokenStorage.saveScrolled();
        this.tempScroll = true;
      }
    });
    this.statusInterval = setInterval(() => {
      // Initialisierung Interval zum Abruf des Status.
      this.myGetStatus();
    }, this.statusIntervalPeriod);
  }

  handleETracker(code: string, cookies: string) {
    const head = this.eTracker.getElementsByTagName('head')[0];
    // const comments = `
    //   <! – Copyright (c) 2000-2021 etracker GmbH. All rights reserved. – >
    //   <! – This material may not be reproduced, displayed, modified or distributed – >
    //   <! – without the express prior written permission of the copyright holder. – >
    //   <! – etracker tracklet 5.0 – >
    // `;
    const scriptVariables = this.eTracker.createElement('script');
    const scriptTracker = this.eTracker.createElement('script');
    scriptVariables.type = 'text/javascript';
    scriptVariables.appendChild(document.createTextNode(``));
    scriptTracker.id = '_etLoader';
    scriptTracker.charset = 'UTF-8';
    scriptTracker.type = 'text/javascript';
    scriptTracker.setAttribute('data-block-cookies', cookies);
    scriptTracker.setAttribute('data-respect-dnt', true);
    scriptTracker.setAttribute('data-secure-code', code);
    scriptTracker.src = '//code.etracker.com/code/e.js';
    scriptTracker.async = true;
    head.appendChild(scriptVariables);
    head.appendChild(scriptTracker);
  }

  myGetStatus() {
    /**
     * Methode wird regelmäßig aufgerufen. Subscribed auf getStatus des Eventservice und erhält den aktuellen Eventstatus.
     * Sendet Kickoff an die myInitSlideInterval um nach erfolgtem initialen Aufruf des Status die Slides regelmäßig abzurufen.
     * Wickelt den Authentifizierungsprozess ab (nyi).
     */
    this.es.getStatus().subscribe(
      (p) => {
        const status = p;
        const previousPhase = this.eStatus?.phase;
        this.eStatus = status;
        this.es.setEventState(status.phase);
        // Nach dem Event mit Aufzeichnung: Umfragen an ihren Stellen im Video, ohne Abstimmung
        if (status.phase === 'post-live' && status.player) this.pollStore.enterVod();
        else this.pollStore.leaveVod();
        if (previousPhase !== 'post-live' && status.phase === 'post-live' && status.slides) {
          // Beim Wechsel auf Post-Live die erste Folie anzeigen
          this.ss.selectFirstSlide();
        }
        setTimeout(() => {
          if (
            this.eStatus.user_strawpoll &&
            this.tokenStorage.getScrolled() === null &&
            this.eStatus.phase === 'live'
          ) {
            setTimeout(() => {
              if (this.screenwidth < 1023) {
                this.togglePodium();
                scrollTo(0, 500);
              } else {
                scrollTo(0, 350);
              }
              this.tokenStorage.saveScrolled();
            }, 500);
          }
        }, 100);

        this.es.setStatusStore(this.eStatus);
        // Get Stream Src für alle Adressen (ext). Dann Entscheidung basierend auf Status und setStream
        this.vs.getStreamSrc(this.uAssigendStream.ip).subscribe(
          (s) => {
            this.eStreamSrc = s;
            // test
            if (s.stream_addr) {
              this.serverDisplay = s.stream_addr;
            }
            if (this.serverDisplay.includes('playout')) {
              this.serverDisplay = 'Server: ' + this.serverDisplay.substring(8, 15);
            } else if (this.serverDisplay.includes('ssl.dev.rwe.com')) {
              this.serverDisplay = 'Server: ' + this.serverDisplay.substring(8, 16);
            } else if (this.serverDisplay.includes('wow-901.video-archiv.info')) {
              this.serverDisplay = 'Server: wow-901';
            } else if (this.serverDisplay.includes('wow-01.video-archiv.info')) {
              this.serverDisplay = 'Server: Extern';
            } else if (this.serverDisplay.includes('wow-02.video-archiv.info')) {
              this.serverDisplay = 'Server: Extern';
            }else if (this.serverDisplay.includes('wow-03.video-archiv.info')) {
              this.serverDisplay = 'Server: Extern';
            } else if (this.serverDisplay.includes('akamai')) {
              this.serverDisplay = 'Server: Cloud A';
            } else if (this.serverDisplay.includes('cdn3.wowza')) {
              this.serverDisplay = 'Server: Cloud';
            }
            // test
            this.mailSubjectServer = ' - ' + this.serverDisplay;
            if (this.eStatus.phase === 'live') {
              this.posterPic =
                this.environmentVars.cssPrefix +
                'assets/images/' +
                this.environmentVars.customer +
                '/live_' +
                this.es.getActiveLang() +
                '.png';
            }
            if (!this.eStatus.slides) {
              this.showQuestions = true;
              this.showSlides = false;
            }
            if (!this.eStatus.slides && !this.eStatus.user_ask_questions) {
              this.showQuestions = false;
              this.showSlides = false;
            }
            if(this.eStatus.phase==='post-live' && this.eStatus.user_vote_questions && this.eStatus.slides && !this.eStatus.player){
              this.showQuestions= false;
              this.showSlides = true;
            }

            if (status.phase === 'live' || status.phase === 'pre-live') {
              this.vs.setPlayerSrc(
                //'https://bitdash-a.akamaihd.net/content/MI201109210084_1/m3u8s/f08e80da-bf1d-4e3d-8899-f0f6155f6efa.m3u8',
                s.stream_addr,
                'application/x-mpegURL'
              );
              this.eStream = this.vs.getPlayerSrc();
              this.pInit = true;
              this.usePlaybackrates = [];
              this.useLiveUi = true;
            } else if (status.phase === 'post-live') {
              this.vs.setPlayerSrc(s.vodPath, 'video/mp4');
              this.eStream = this.vs.getPlayerSrc();
              this.pInit = true;
              this.usePlaybackrates = [0.75, 1, 1.25, 1.5, 2];
              this.useLiveUi = false;
            }
          },
          (err) => this.logger.log('HTTP Error ' + err)
        );
        if (this.es.getActiveLang() === 'de') {
          this.eEmergency = this.eStatus.emergency_txt_de;
          this.eOptionalTxt = this.eStatus.optional_txt_de;
          this.eOptionalLink = this.eStatus.optional_link_de;
          this.eOptionalLinkDesc = this.eStatus.optional_linkdesc_de;
        } else if (this.es.getActiveLang() === 'en') {
          this.eEmergency = this.eStatus.emergency_txt_en;
          this.eOptionalTxt = this.eStatus.optional_txt_en;
          this.eOptionalLink = this.eStatus.optional_link_en;
          this.eOptionalLinkDesc = this.eStatus.optional_linkdesc_en;
        } else if (this.es.getActiveLang() === 'nl') {
          this.eEmergency = this.eStatus.emergency_txt_nl;
          this.eOptionalTxt = this.eStatus.optional_txt_nl;
          this.eOptionalLink = this.eStatus.optional_link_nl;
          this.eOptionalLinkDesc = this.eStatus.optional_linkdesc_nl;
        }
      },
      (err) => this.logger.log('HTTP Error ' + err)
    );
  }

  myGetActiveSlide() {
    /**
     * Ruft aktuell angezeigte Slide ab.
     */
    this.eActiveSlide = this.es.getActiveSlide();
  }

  myReturnToLiveSlide() {
    /**
     * Setzt die aktuell angezeigte Slide auf die aktuelle Live-Slide zurück.
     */
    this.slideIsCustom = false;
    this.es.setSlideToLive();
    const parentElement = this.slideHistoryChild.nativeElement;
    const firstDiv = parentElement.querySelector('div.coverflow_style');
    firstDiv.scrollTo({ left: firstDiv.scrollWidth, behavior: 'smooth' });
  }

  // Methode, die vom Button aufgerufen wird
  resortUserVoteQuestions(sortBy: string) {
    this.listReorderService.sortBy = sortBy;
    if (this.userVoteQuestionList) {
      this.userVoteQuestionList.resortQuestions();
    }
  }

  showElement(elem: string) {
    if (elem === 'slides') {
      this.showQuestions = false;
      this.showSlides = true;
      this.showPolls = false;
    }
    if (elem === 'questions') {
      this.showQuestions = true;
      this.showSlides = false;
      this.showPolls = false;
    }
    if (elem === 'polls') {
      this.showPolls = true;
    }
  }

  /**
   * Umfrage-Tab im Header (nur Desktop), nur im Layout mit rechter Spalte (Folien oder
   * Fragen) — ohne rechte Spalte steht die Umfrage als aufklappbarer Bereich unter dem Player.
   * Vor und während des Events: Sind Umfragen in der CCP eingeschaltet, ist der Tab immer da;
   * ohne Umfrage zeigt er einen Hinweis, dass hier gleich eine erscheint. Nach dem Event nur
   * mit Aufzeichnung, in der Umfragen liefen — sie erscheinen dann an ihrer Stelle im Video.
   */
  pollTabAvailable(): boolean {
    if (!this.eStatus?.slides && !this.eStatus?.user_ask_questions) return false;
    if (this.eStatus.phase === 'post-live') return !!this.eStatus.player && this.pollStore.vodAvailable();
    return this.pollStore.enabled() || this.pollStore.polls().length > 0;
  }

  /** Fällt von selbst zurück, sobald der Tab wegfällt (Umfragen aus und keine Umfrage mehr da) */
  pollsTabActive(): boolean {
    return this.showPolls && this.pollTabAvailable();
  }

  // Mit Umfrage-Tab braucht es Präsentation und Fragen auch dort als Tab, wo es bisher keinen
  // Umschalter gab — sonst käme man vom Umfrage-Tab nicht mehr zurück.
  slidesTabForPolls(): boolean {
    return this.pollTabAvailable() && !!this.eStatus.slides;
  }

  pollQuestion(poll: ViewerPoll): string {
    return pollText(poll.question, this.activeLang(), poll.defaultLang);
  }

  pollTabLabel(poll: ViewerPoll): string {
    return pollTabLabel(poll, this.activeLang());
  }

  /** Header-Tab eines Eintrags: die Frage, bei einer Kette ihr Titel */
  pollItemLabel(item: PollItem): string {
    return pollItemLabel(item, this.activeLang(), this.eLangGlob?.translatePollSeries ?? '');
  }

  pollItemTitle(item: PollItem): string {
    return item.kind === 'poll' ? this.pollQuestion(item.poll) : itemPolls(item).map((poll) => this.pollQuestion(poll)).join(' · ');
  }

  pollItemOpen(item: PollItem): boolean {
    return itemPolls(item).some((poll) => poll.status === 'open');
  }

  questionsTabForPolls(): boolean {
    return (
      this.pollTabAvailable() &&
      (!!this.eStatus.user_see_questions || (!!this.eStatus.user_ask_questions && !this.eStatus.slides))
    );
  }

  toggleSlideMobile() {
    this.showSlideMobile = this.showSlideMobile === 'out' ? 'in' : 'out';
  }

  togglePodium() {
    this.showPodium = this.showPodium === 'out' ? 'in' : 'out';
  }

  isLoading = true;

  switchLang(lang: string) {
    if (this.es.getActiveLang() !== lang) {
      this.isLoading = true;
      const url = window.location.href.split('?')[0];
      if (this.mFromMediaLib) {
        window.location.href = url + '?ln=' + lang + '&medialib=' + this.mToken + '&back=' + this.mBackLinkEncoded;
      } else {
        window.location.href = url + '?ln=' + lang;
      }
    }
  }

  paginateVodList(page) {
    this.vodList.handlePageChange(page);
    this.vodQDisplay = this.vodList.getFromTo();
    this.vodFrom = this.vodQDisplay[0];
    this.vodTo = this.vodQDisplay[1];
  }

  toggleBurger() {
    // window.scroll({top:0})
    this.hamburger = !this.hamburger;
    if (this.hamburger) {
      this.down = false;
      document.body.style.overflow = 'hidden';
      // document.getElementById("hr_logos").style.position= "fixed";
      document.body.style.height = '100vh';
    } else {
      document.body.style.overflow = 'auto';
      // document.getElementById("hr_logos").style.position= "relative";
      document.body.style.height = 'auto';
    }
  }

  closeBurger() {
    this.hamburger = false;
    document.body.style.overflow = 'auto';
  }

  toggleDown(closeHam: boolean) {
    this.down = !this.down;
    if (this.down && closeHam) {
      this.hamburger = false;
    }
  }

  toggleSidebarDescription() {
    this.showSidebarDescription = this.showSidebarDescription === 'out' ? 'in' : 'out';
  }

  toggleEventDescription() {
    this.showEventDescription = this.showEventDescription === 'out' ? 'in' : 'out';
  }

  logout() {
    window.location.href = this.mBackLinkDecoded + '?ln=' + this.eLangUsed + '&logout=true';
  }

  closeDown() {
    this.down = false;
  }

  toggleHamburger() {
    this.showHamburger = !this.showHamburger;
  }

  onClickedOutsideToggleHamburger(e: Event) {
    this.showHamburger = false;
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    if (this.mFromMediaLib) {
      window.sessionStorage.clear();
    }
  }

  setEventWatcherSocketConnection() {
    this.socketEventWatcher = io(this.SOCKET_ENDPOINT + 'event_watcher', {
      path: `/v1/${this.nodeServiceUrl}/socket/`,
      auth: {
        token: this.es.getInitCipher(),
        customer: environment.customerShort,
        instance: 'event'
      }
    });
    this.socketEventWatcher.on('update_quality_levels', (qualityLevels) => {
      this.playerComponent.updateQuality(qualityLevels);
    });
  }

  questionCount(count) {
    this.vodCount = count;
  }
}
